import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterInvisible'
})
export class FilterInvisiblePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.filter(_item => !_item.invisible);
  }

}
